import { Component, OnInit } from '@angular/core';
import { HumanResourceService } from '../../services/human-resource.service';
import { MasterDataService } from '../../services/master-data.service';
import * as moment from 'moment';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-client-conveyance-assignment',
  templateUrl: './client-conveyance-assignment.component.html',
  styleUrls: ['./client-conveyance-assignment.component.css'],
})
export class ClientConveyanceAssignmentComponent implements OnInit {
  selectedFinancialYear;
  financialList;
  selectedBranch;
  isBranchSelected = false;
  branchList;
  selectedClientStatus;
  selectBillingDate;
  billingDateList;
  selectClientName;
  clientNameList;
  clientConveyanceAssignmentList;
  clientBilledConveyanceList;
  clientMonthlyConveyanceList;
  showClientConveyanceAssignmentDetails = true;
  showMonthlyConveyanceDetails = false;
  showBilledConveyanceDetails = false;
  allBillingAmountTotal;
  totalTwoWheelerCount;
  totalFourWheelerCount;
  totalBusAutoCount;
  totalBilledConveyanceCount;
  totalMonthlyConveyanceCount;
  lastBilledDate;
  userRole;
  accessResponse: any;

  constructor(
    private masterDataService: MasterDataService,
    private humanResourceService: HumanResourceService,
    private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService

  ) { }

  ngOnInit(): void {
    this.selectedFinancialYear = '';
    this.selectedClientStatus = "";
    this.selectBillingDate = '';
    this.selectClientName = '';
    this.selectedBranch = '';
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });

    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  onSelectBranch() {
    this.selectClientName = '';
    this.selectedClientStatus = '';
    this.clientNameList = [];
    // if (
    //   this.selectedFinancialYear != '' &&
    //   this.selectedFinancialYear != null &&
    //   this.selectedFinancialYear != undefined &&
    //   this.selectedBranch != '' &&
    //   this.selectedBranch != null &&
    //   this.selectedBranch != undefined
    // ) {
    //   this.humanResourceService
    //     .getClientsByBranch(this.selectedBranch)
    //     .subscribe((res: any) => {
    //       if (res.length > 0) {
    //         this.clientNameList = res;
    //       } else {
    //          this.commonMessageService.swalAlertWithoutIcon('','Client not present for this selectedBranch');
    //       }
    //     });
    // }
  }

  onStatusSelect() {
    this.selectClientName = '';
    if (
      this.selectedFinancialYear != '' &&
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedBranch != '' &&
      this.selectedBranch != null &&
      this.selectedBranch != undefined &&
      this.selectedClientStatus != '' &&
      this.selectedClientStatus != undefined
    ) {
      console.log('this.branch', this.selectedBranch, this.selectedClientStatus);
      this.masterDataService.getClientListByBranchStatus(this.selectedBranch, this.selectedClientStatus).subscribe((resp: any) => {
        console.log('response details client list', resp);
        if (resp.length > 0) {
          this.clientNameList = resp;
        } else {
          //  this.commonMessageService.swalAlertWithoutIcon('','Client not present for this selectedBranch');
        }
      });
    }
  }

  onSelectClientName() {
    this.selectBillingDate = '';
    this.showExportToExcelButton = false;
    this.clientConveyanceAssignmentList = null;
    if (
      this.selectClientName != '' &&
      this.selectClientName != null &&
      this.selectClientName != undefined
    ) {
      this.humanResourceService
        .getClientBillingDate(
          this.selectClientName,
          this.selectedFinancialYear.id
        )
        .subscribe((res: any) => {
          console.log('billing date list', res);
          this.billingDateList = res;
          this.lastBilledDate = this.billingDateList[
            this.billingDateList.length - 1
          ];
          console.log('this.lastBilledDate', this.lastBilledDate);

        });
    }
  }

  showExportToExcelButton = false;
  onViewReport() {
    if (
      this.selectedFinancialYear == '' ||
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectBillingDate == '' ||
      this.selectBillingDate == null ||
      this.selectBillingDate == undefined ||
      this.selectClientName == '' ||
      this.selectClientName == null ||
      this.selectClientName == undefined ||
      this.selectedBranch == '' ||
      this.selectedBranch == null ||
      this.selectedBranch == undefined
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }

    this.showExportToExcelButton = false;

    this.humanResourceService
      .getClientConveyanceAssignmentReport(
        this.selectClientName,
        this.selectBillingDate.id,
        this.selectedFinancialYear.id
      )
      .subscribe((res: any) => {
        console.log('client Conveyance Report List', res);
        this.clientConveyanceAssignmentList = res;
        if (this.clientConveyanceAssignmentList != null) {
          this.showExportToExcelButton = true;
          this.AllBillingAmountTotal();
        } else {
          this.commonMessageService.swalAlertWithoutIcon('', "No Record Found");
        }
      });
  }

  exportToExcelClientAssignment() {
    this.humanResourceService
      .getClientConveyanceAssignmentReportExportToExcel(
        this.selectClientName,
        this.selectBillingDate.id,
        this.selectedFinancialYear.id
      )
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "ClientConveyanceAssignmentReport.xlsx";
        link.click();
      });
  }

  AllBillingAmountTotal() {
    var allBillingAmount = 0;
    this.clientConveyanceAssignmentList.assignments.map((res) => {
      res.diaryClosingDates.map((res1) => {
        res1.periods.map((res2) => {
          allBillingAmount += res2.amount;
        });
      });
      allBillingAmount += res.travellingAllowance;
    });
    this.allBillingAmountTotal = Math.round(allBillingAmount);
    console.log('allBillingAmount', allBillingAmount, 'this.allBillingAmountTotal ', this.allBillingAmountTotal);
  }

  getRowSpanForClient(client) {
    var count = 0;
    client.diaryClosingDates.map((res) => {
      res.periods.map((res1) => {
        count++;
      });
    });
    return count;
  }

  calculateBillingAmountByPeriod(periodList) {
    var billingAmountByPeriod = 0;
    periodList.map((res1) => {
      billingAmountByPeriod += res1.amount;
    });
    return billingAmountByPeriod;
  }

  calculateBillingAmountByDate(diaryClosingDateList) {
    var billingAmountByDate = 0;
    diaryClosingDateList.map((res) => {
      res.periods.map((res1) => {
        billingAmountByDate += res1.amount;
      });
    });
    return billingAmountByDate;
  }

  goBack() {
    this.showClientConveyanceAssignmentDetails = true;
    this.showMonthlyConveyanceDetails = false;
    this.showBilledConveyanceDetails = false;
  }

  billedClientdId;
  billedBillingId;
  billedAssignmentId;
  getClientBilledConveyanceList(clientId, billingId, assignmentId) {
    this.billedClientdId = clientId;
    this.billedBillingId = billingId;
    this.billedAssignmentId = assignmentId;
    this.humanResourceService
      .getClientByBilledConveyanceAssignmentReport(
        clientId,
        billingId,
        assignmentId
      )
      .subscribe((res: any) => {
        console.log('client ConveyancebilledReport List', res);
        this.clientBilledConveyanceList = res;
        if (this.clientBilledConveyanceList == null) {
          this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found in Billed conveyance Report');
          return;
        }
        this.showClientConveyanceAssignmentDetails = false;
        this.showBilledConveyanceDetails = true;
        this.calculateTotalBilledConveyanceDetails();
      });
  }

  exportToExcelClientBilledConveyance() {
    this.humanResourceService
      .getClientByBilledConveyanceAssignmentExportToExcelReport(
        this.billedClientdId,
        this.billedBillingId,
        this.billedAssignmentId
      )
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "ClientBilledConveyanceReport.xlsx";
        link.click();
      });
  }

  getRowSpanForDiaryDate(diaryDate) {
    var count = 0;
    diaryDate.diaryDetails.map((res) => {
      count++;
    });
    return count;
  }

  changeMonthNumberToName(month) {
    return moment(month, 'M').format('MMM');
  }

  calculateTotalBilledConveyanceDetails() {
    this.totalTwoWheelerCount = 0;
    this.totalFourWheelerCount = 0;
    this.totalBusAutoCount = 0;
    this.totalBilledConveyanceCount = 0;
    var totalTwoWheeler = 0;
    var totalFourWheeler = 0;
    var totalBusAuto = 0;
    var totalBilledConveyance = 0;
    this.clientBilledConveyanceList.diaryDates.map((res) => {
      res.diaryDetails.map((res1) => {
        totalTwoWheeler += res1.twoWheeler;
        this.totalTwoWheelerCount = Math.round(totalTwoWheeler);
        totalFourWheeler += res1.fourWheeler;
        this.totalFourWheelerCount = Math.round(totalFourWheeler);
        totalBusAuto += res1.busAuto;
        this.totalBusAutoCount = Math.round(totalBusAuto);
        totalBilledConveyance += res1.billedConveyance;
        this.totalBilledConveyanceCount = Math.round(totalBilledConveyance);
      });
    });
  }

  monthlyClientId;
  monthlyClosingDateId;
  monthlyBillingId;
  monthlyAssignmentId;
  monthlyMonth;
  monthlyYear;
  getClientMonthlyConveyanceList(
    clientId,
    closingDateId,
    billingId,
    assignmentId,
    month,
    year
  ) {
    this.monthlyClientId = clientId;
    this.monthlyClosingDateId = closingDateId;
    this.monthlyBillingId = billingId;
    this.monthlyAssignmentId = assignmentId;
    this.monthlyMonth = month;
    this.monthlyYear = year;
    this.humanResourceService
      .getClientByMonthlyConveyanceAssignmentReport(
        clientId,
        closingDateId,
        billingId,
        assignmentId,
        month,
        year
      )
      .subscribe((res: any) => {
        console.log('client Monthly Conveyance Report List', res);
        this.clientMonthlyConveyanceList = res;
        if (this.clientMonthlyConveyanceList == null) {
          this.commonMessageService.swalAlertWithoutIcon('', 'No Record Found in Monthly conveyance Report');
          return;
        }
        this.showClientConveyanceAssignmentDetails = false;
        this.showMonthlyConveyanceDetails = true;
        this.calculateTotalConveyanceDetails();
      });
  }

  exportToExcelClientMonthlyConveyanceList() {
    this.humanResourceService
      .getClientByMonthlyConveyanceAssignmentExportToExcelReport(
        this.monthlyClientId,
        this.monthlyClosingDateId,
        this.monthlyBillingId,
        this.monthlyAssignmentId,
        this.monthlyMonth,
        this.monthlyYear
      )
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "ClientMonthlyConveyanceReport.xlsx";
        link.click();
      });
  }

  calculateTotalConveyanceDetails() {
    this.totalMonthlyConveyanceCount = 0;
    var total = 0;
    if (this.clientMonthlyConveyanceList != null) {
      this.clientMonthlyConveyanceList.diaryDates.map((res) => {
        res.diaryDetails.map((res1) => {
          total += res1.totalConveyance;
          this.totalMonthlyConveyanceCount = Math.round(total);
        });
      });
    }
  }

  changeMonthToNumberMonthlyConveyance(month) {
    return moment(month, 'M').format('MMM');
  }
}
